<template>
  <div>
    <wc-data-box
      :title='header.title'
      :titleIcon='header.icon'
      :titleIconColor='header.iconColor'
      showEdit
      @edit='editDetails'
      showHelp
      :helpText='helpText'
    >
      <wc-two-column-table
        :items='details'
        @rowClick='editDetails'
      ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='header.title'
      :icon='header.icon'
      :iconColor='header.color'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <details-form v-model='divisionCopy'></details-form>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import DetailsForm from '../../components/forms/DetailsForm'
import _ from 'lodash'
export default {
  name: 'division-details',
  props: {
    division: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    divisionCopy: {},
    showDialog: false
  }),
  computed: {
    header () {
      return this.$store.state.icons.dataBox.details
    },
    details () {
      let table = [
        { text: 'Division prefix', value: this.division.division_prefix },
        { text: 'Commercial project prefix', value: this.division.comm_project_letter },
        { text: 'Residential project prefix', value: this.division.ress_project_letter },
        { text: 'Residential Start Up Date', value: this.$options.filters.shortDate(this.division.season_starts) },
        { text: 'Residential End Date', value: this.$options.filters.shortDate(this.division.season_ends) },
        { text: 'Days until invoice due:', value: this.division.days_until_invoice_due },
        { text: 'Monthly invoice interest:', value: this.division.invoice_interest + ' %' },
        { text: 'Residential margin:', value: this.$options.filters.decMoney(this.division.ressy_margin) },
        { text: 'Commercial margin:', value: this.$options.filters.decMoney(this.division.comm_margin) },
        { text: 'Estimate markup:', value: this.$options.filters.percentage(this.division.estimate_markup) },
        { text: 'Invoice terms:', value: this.division.invoice_terms }
      ]
      return table
    },
    helpText () {
      return `
        <strong>Invoice prefix:</strong><br>
        The character to put at the beginning of invoice numbers. For example, the "R" in invoice number "R-20201023-3245"<br>
        <br>
        <strong>Commercial/Residential project numbers:</strong><br>
        The character to put at the beginning of a commercial project number. For example, the "C" in commercial irrigation project "C1234"
        <br>
        <br>
        <strong>Icon/Icon color:</strong><br>
        The icon and color that best represents the division.
      `
    }
  },
  methods: {
    editDetails () {
      this.divisionCopy = _.cloneDeep(this.division)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.divisionCopy)
      this.showDialog = false
    }
  },
  components: {
    'details-form': DetailsForm
  }
}
</script>